import { ForbiddenError, UnauthorizedError, UnexpectedError } from '../errors';

import { SEND_RESPONSABLE_URL } from '@/constants';
import { HttpStatusCode, fromRiskBff, httpClient } from '@/utils';

import { SendResponsiblePayload } from './types';

export const sendResponsibleService = async (data: SendResponsiblePayload): Promise<void> => {
  const httpsResponse = await httpClient.post(fromRiskBff(SEND_RESPONSABLE_URL), data);

  switch (httpsResponse.status) {
    case HttpStatusCode.created:
      return;

    case HttpStatusCode.unauthorized:
      throw new UnauthorizedError();

    case HttpStatusCode.forbidden:
      throw new ForbiddenError('Você não possui permissão para isto.');

    default:
      throw new UnexpectedError();
  }
};
